import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { logOut, getUserData, updateUserData } from "../../api";
import { showNotification } from "../../config";

export const getUserAsyncThunk = createAsyncThunk("getUserAsync", () => getUserData());
export const logOutAsyncThunk = createAsyncThunk("logOutAsync", () => logOut());
export const updateUserAsyncThunk = createAsyncThunk("updateUserAsync", (data) => updateUserData(data));

let initialState = {
  isPending: false,
  isError: false,
  token: null,
  user: null,
  screen: {
    mobile: false,
    tablet: false,
    desktop: false,
  },
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    resize: (state, { payload }) => {
      state.screen = { ...initialState.screen, [payload.key]: payload.value };
    },
    setScrollDisable: (state, { payload }) => {
      state.scrollDisable = payload;
    },
    saveToken: (state, { payload }) => {
      if(payload) {
        state.token = payload;
      } else {
        state.token = null;
        state.user = null;
      }
    },
  },
  extraReducers: {
    // --- getUser --- //
    [getUserAsyncThunk.pending]: (state) => {
      state.isError = false;
      state.isPending = true;
    },
    [getUserAsyncThunk.fulfilled]: (state, action) => {
      state.user = action.payload?.data;
    },
    [getUserAsyncThunk.rejected]: (state) => {
      state.isError = true;
      state.isPending = false;
    },

    // --- logOut --- //
    [logOutAsyncThunk.pending]: (state) => {
      state.isError = false;
      state.isPending = true;
    },
    [logOutAsyncThunk.fulfilled]: (state) => {
      state.isPending = false;
      state.token = null;
      state.user = null;
    },
    [logOutAsyncThunk.rejected]: (state) => {
      state.isError = true;
      state.token = null;
      state.user = null;
      state.isPending = false;
    },

    // --- updateUser --- //
    [updateUserAsyncThunk.pending]: (state) => {
      state.isError = false;
      state.isPending = true;
    },
    [updateUserAsyncThunk.fulfilled]: (state, action) => {
      state.isPending = false;
      state.user = {...state.user, ...action.payload.newData};
      action.payload.reset({...state.user, ...action.payload.newData});
      showNotification("User updated successfully", "success");
    },
    [updateUserAsyncThunk.rejected]: (state) => {
      state.isError = true;
      state.isPending = false;
      showNotification("Something went wrong, try again later!");
    },
  },
});

export const { resize, setScrollDisable, saveUserData, saveToken } = userSlice.actions;
export const userReducer = userSlice.reducer;
